export { default } from './resources-list.jsx';